import React, { useEffect, useState } from "react";
import facebook from "../../Assets/img/facebook.svg";
import linkedIn from "../../Assets/img/linkedIn.svg";
import X from "../../Assets/img/X.svg";
import { useDispatch, useSelector } from "react-redux";
import { getProductsInfo } from "../../Core/features/checkoutSlice";
import Loader from "../Loader";
import { setTabsToDisplay } from "../../Core/features/tabsSlice";
import ContactUs from "../ContactUs";
import SimpleProduct from "../SimpleProduct";
import SubProducts from "../SubProducts/indexj";

const ProductRec = ({ tab_name, currentTab, handleNext }) => {
  const dispatch = useDispatch();
  // const [loader, setLoader] = useState(true)
  const { tabs, tabsToDisplay } = useSelector((state) => state.TabsState);
  const { productInfo, isProductLoading } = useSelector(
    (state) => state.CheckoutState
  );
  useEffect(() => {
    if (tab_name === "Product Reccomendations") {
      dispatch(getProductsInfo(tabs));
    }
  }, [currentTab]);

  return (
    <div class="form-step active" id="step-7">

      <div class="package_container">
        {!productInfo || isProductLoading ? <Loader /> : (<>
          {Array.isArray(productInfo) && productInfo.length == 0 ? (<>
            <h2>No Product Found</h2>
          </>) : (
            <>
              {productInfo?.contact_us ? (
                <ContactUs productInfo={productInfo} />
              ) : productInfo?.sub_products?.length > 0 ? (<>
                <SubProducts productInfo={productInfo} />
              </>
              ) : (
                <SimpleProduct productInfo={productInfo} />
              )}
              {!productInfo?.contact_us && (
                <>                <h2 class="amount price-amount">${productInfo?.product_price}</h2>
                  <div class="purchase_btn_wrapper">
                    <button
                      onClick={handleNext}
                      id="step_6_nextBtn"
                      class="nextBtn purchase_btn"
                    >
                      Next
                    </button>
                  </div>
                </>

              )}

            </>
          )}
        </>
        )}

      </div>

      {/* <div class="social_icon">
        <ul>
          <li>
            <p>Follow:</p>
          </li>
          <li>
            <a
              target="_blank"
              href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fgbstax.typeform.com%2Fto%2FB7VGh40O%3Ftypeform-ty-screen-ref%3D779be418-1073-4b36-9ca7-f7d3604350cf
"
            >
              <img src={facebook} alt="facebook" />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href="https://www.x.com/intent/post?url=https%3A%2F%2Fgbstax.typeform.com%2Fto%2FB7VGh40O%3Ftypeform-ty-screen-ref%3D779be418-1073-4b36-9ca7-f7d3604350cf"
            >
              <img src={X} alt="X" />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Furl%3Dhttps%253A%252F%252Fgbstax.typeform.com%252Fto%252FB7VGh40O%253Ftypeform-ty-screen-ref%253D779be418-1073-4b36-9ca7-f7d3604350cf
"
            >
              <img src={linkedIn} alt="linkedIn" />
            </a>
          </li>
        </ul>
      </div> */}
    </div>
  );
};

export default ProductRec;
